import { getInstance } from '../tools';

export function login(data) {
    return getInstance().post('/api/auth/login', data);
}

export function restorePassword(data) {
    return getInstance().post('/api/auth/restore-password', data)
}